// import React, { useState } from "react";
// import Dialog from "./Dialog";
// import tabBar from "../../assets/images/weekly star image/notactive.png";
// import activeTabBar from "../../assets/images/weekly star image/activerBar.png";

// import DialogButton from "../../assets/images/weekly star image/dialog.png";
// import coin from "../../assets/images/weekly star image/New folder/ic_coin 4.png";

// import FirstWeeklyStarBg from "../../assets/images/weekly star image/FirstWeeklyStarBg.png";
// import Top1 from "../../assets/images/weekly star image/top1.png";
// import Top2 from "../../assets/images/weekly star image/Top2.png";
// import Top3 from "../../assets/images/weekly star image/Top3.png";
// import reward from "../../assets/images/weekly star image/singleRewardBG.png";
// import Rank1 from "../../assets/images/weekly star image/Rank1.png";
// import Rank2 from "../../assets/images/weekly star image/Rank2.png";
// import Rank3 from "../../assets/images/weekly star image/Rank3.png";
// import weeklyStarGiftBackground from "../../assets/images/weekly star image/weeklyStarGiftBG.png";

// import fallbackGift from "../../assets/icons/gift-box 1.png";
// import fallbackMale from "../../assets/icons/selected_male.png";
// import fallbackFemale from "../../assets/icons/selected_male.png";

// import { useTranslation } from "react-i18next";
// import TimerComponent from "./TimerComponent";
// import AutoPlayVideoWithSound from "./AutoPlayVideoWithSound";

// const Design = ({
//   topDetails,
//   roleEventData,
//   userGiftsTop,
//   userGiftsTopHours,
//   topWeeklyData,
// }) => {
//   const [isDialogOpen, setIsDialogOpen] = useState(false);
//   const openDialog = () => setIsDialogOpen(true);
//   const closeDialog = () => setIsDialogOpen(false);
//   const [activeTab, setActiveTab] = useState("tab1");
//   const [activeTab1, setActiveTab1] = useState("tab4");
//   const ImageBaseUrl = "https://media.sh8afchat.com/";
//   const [imageErrors, setImageErrors] = useState({});
//   // Handle image error by updating the imageErrors state
//   const handleError = (itemId) => {
//     setImageErrors((prevState) => ({
//       ...prevState,
//       [itemId]: true, // Mark this item image as failed to load
//     }));
//   };
//   const { t } = useTranslation();
//   // Rank images mapping
//   const rankImages = {
//     1: Rank1,
//     2: Rank2,
//     3: Rank3,
//   };
//   // Reusable Score Badge Component
//   const ScoreBadge = ({ score }) => (
//     <p className="text-shadow-[2px_2px_5px_rgba(0,0,0,0.3)] px-2  text-sm text-[#FCEA98] flex flex-row items-center gap-1   font-mono font-semibold text-[16px] leading-[54.32px]">
//       <img src={coin} alt="coin" className="w-5 h-5" />
//       {parseInt(score) || "--"}
//     </p>
//   );

//   // Reusable Avatar Image Component
//   const AvatarImage = ({ imageUrl, size = "w-14 h-14" }) => (
//     <img
//       src={imageErrors[imageUrl] ? fallbackMale : `${ImageBaseUrl}${imageUrl}`}
//       onError={() => handleError(imageUrl)}
//       className={`${size} rounded-full border-2 border-[#E6DE7F] shadow-md`}
//       alt="avatar"
//     />
//   );
//   // Reusable Winner List Item Component
//   const WinnerListItem = ({ item, position }) => (
//     <div className="WeeklyRankBackground   my-2    ">
//       <div className="flex flex-row px-2 justify-center items-center gap-1 h-full">
//         <div className="w-[70%] flex flex-row items-center">
//           <p className="font-semibold w-[15%] text-lg text-[#FDF19F] font-tajawal">
//             {position}
//           </p>
//           <div className="relative flex flex-row items-center gap-2">
//             <AvatarImage imageUrl={item.avatar} size="w-14 h-14" />
//             <div className="px-2">
//               <p className="text-[#FCEA98] font-cairo text-sm font-bold">
//                 {item.name}
//               </p>
//               <p className="text-white font-cairo text-sm font-semibold">
//                 ID : {item.user_id}
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="w-[25%] flex flex-row justify-end  items-center">
//           <ScoreBadge score={item.totalGiftNum} />
//         </div>
//       </div>
//     </div>
//   );
//   // Reusable Winners List Component
//   const WinnersList = ({ winners }) => {
//     if (!winners || winners.length === 0) return null;

//     return (
//       <div className="mx-auto w-[92%]   flex flex-col gap-2 relative">
//         {winners.map((item, index) => (
//           <WinnerListItem key={index} item={item} position={index + 4} />
//         ))}
//       </div>
//     );
//   };

//   const RankingCard = ({ rank, userData, rankImage, className = "" }) => {
//     const rankConfig = {
//       1: {
//         containerHeight: "h-[261px]",
//         avatarSize: "w-[75px] h-[75px]",
//         avatarPosition: "top-[60px]",
//         contentPosition: "bottom-11",
//         textSize: { name: "text-sm", id: "text-sm", gifts: "text-sm" },
//       },
//       2: {
//         containerHeight: "h-[195px]",
//         containerWeight: "w-[155px]",

//         avatarSize: "w-[65px] h-[65px]",
//         avatarPosition: "top-[30px]",
//         contentPosition: "bottom-9",
//         textSize: { name: "text-xs", id: "text-xs", gifts: "text-xs" },
//       },
//       3: {
//         containerHeight: "h-[195px]",
//         containerWeight: "w-[155px]",

//         avatarSize: "w-[65px] h-[65px]",
//         avatarPosition: "top-[30px]",
//         contentPosition: "bottom-9",
//         textSize: { name: "text-xs", id: "text-xs", gifts: "text-xs" },
//       },
//     };

//     const config = rankConfig[rank];

//     if (!userData) return null;

//     return (
//       <div className={`relative ${className}`}>
//         <img
//           src={rankImage}
//           alt={`Rank ${rank}`}
//           className={`${config.containerHeight} ${config.containerWeight} mx-auto  relative z-30 object-cover rounded-2xl`}
//         />

//         <img
//           src={
//             imageErrors[userData?.avatar] // ✅ if error, use fallback
//               ? fallbackMale
//               : `${ImageBaseUrl}${userData?.avatar}`
//           }
//           onError={() => handleError(userData?.avatar)} // ✅ just pass image path
//           alt={userData?.name}
//           className={`absolute ${config.avatarPosition} left-1/2 z-10 transform -translate-x-1/2 rounded-xl ${config.avatarSize} object-cover shadow-lg`}
//         />

//         <div className={`absolute ${config.contentPosition} w-full z-30 px-2`}>
//           <p
//             className={`text-[#FCEA98] font-semibold w-[50%] mx-auto truncate ${config.textSize.name}`}
//           >
//             {userData?.name}
//           </p>
//           <p className={`text-white ${config.textSize.id}`}>
//             ID: {userData?.user_id}
//           </p>
//           <p
//             className={`gradientText font-semibold ${config.textSize.gifts} text-[12px] flex flex-row font-cairo justify-center gap-1 items-center text-center font-extrabold gradientText  `}
//           >
//             <img src={coin} alt="coin" className="h-[13px]" />
//             <span className="text-[#FCEA98]"> {userData?.totalGiftNum}</span>
//           </p>
//         </div>
//       </div>
//     );
//   };
//   const renderTabContent = () => {
//     if (activeTab === "tab1") {
//       return (
//         <div className="tab-panel relative pt-10 flex flex-col justify-center gap-5 items-center text-center">
//           <div className="event-tabs RewardBg overflow-hidden z-40 relative flex flex-col items-end w-full">
//             <div className="h-36 w-full"></div>
//             <div className="flex   overflow-y-scroll    relative flex-wrap  mx-auto h-[80%] justify-end">
//               <div className="flex relative   flex-wrap  mx-auto  justify-between w-[75%]">
//                 {roleEventData?.weekly_event?.gifts?.map((item, index) => (
//                   <div className="flex flex-col w-[30%] relative">
//                     {" "}
//                     <img
//                       src={weeklyStarGiftBackground}
//                       alt="weekly Star Reward Background"
//                       className="inset-0 w-full object-cover rounded-2xl"
//                     />
//                     <img
//                       src={
//                         imageErrors[item?.image] // Check if this image has an error
//                           ? fallbackGift
//                           : `${ImageBaseUrl}${item?.image}`
//                       }
//                       onError={() => handleError(item?.image)} // Handle error for individual image
//                       alt={item?.name}
//                       className="w-[60px] h-[60px] absolute bottom-[43px] left-1/2 transform -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
//                     />{" "}
//                     <div className="flex GiftTextBg flex-row justify-center items-center gap-1">
//                       <img
//                         src={coin}
//                         alt="weekly Star Reward Background"
//                         className=" w-[15px] "
//                       />
//                       <p className=" font-tajawal w-[20%]   p-2 z-40  text-[#FCEA98]  text-[8px] font-normal text-center">
//                         {item?.price}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="   h-full w-full mx-auto">
//                 <div className="relative  flex flex-col justify-center items-center text-center w-full">
//                   <div className="relative w-full">
//                     <RankingCard
//                       rank={1}
//                       userData={topWeeklyData?.top?.[0]}
//                       rankImage={rankImages[1]}
//                     />
//                   </div>

//                   <div className="flex flex-row relative -top-5 justify-center items-center   w-full">
//                     {[2, 3].map((rank) => (
//                       <div key={rank} className="relative  ">
//                         <RankingCard
//                           rank={rank}
//                           userData={topWeeklyData?.top?.[rank - 1]}
//                           rankImage={rankImages[rank]}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <WinnersList winners={topWeeklyData?.top.slice(3)} />
//               </div>
//             </div>
//             <div className="relative w-full fixedWeeklyStar ">
//               {" "}
//               {topWeeklyData?.user && (
//                 <div className="flex flex-row px-6 justify-center items-center gap-1 h-full">
//                   <div className="w-[70%] flex flex-row items-center">
//                     <div className="relative flex flex-row items-center gap-2">
//                       <AvatarImage
//                         imageUrl={topWeeklyData?.user.avatar}
//                         size="w-14 h-14"
//                       />
//                       <div className="px-2">
//                         <p className="text-[#FCEA98] font-cairo text-sm font-bold">
//                           {topWeeklyData?.user.name}
//                         </p>
//                         <p className="text-white font-cairo text-sm font-semibold">
//                           ID : {topWeeklyData?.user.user_id}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="w-[25%] flex flex-row justify-end  items-center">
//                     <ScoreBadge score={topWeeklyData?.user.totalGiftNum} />
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       );
//     } else if (activeTab === "tab3") {
//       return (
//         <div className="tab-panel relative pt-9 flex flex-col justify-center h-full gap-6 items-center text-center">
//           <div className="event-tabs RewardBg overflow-hidden z-40 relative flex flex-col items-end w-full">
//             {" "}
//             <div className="h-32 w-full"></div>
//             <div className="flex  overflow-y-scroll h-[90%]    px-2    relative flex-col  mx-auto  justify-start">
//               <div>
//                 <img
//                   src={FirstWeeklyStarBg}
//                   alt="FirstWeeklyStarBg"
//                   className=" w-[90%] m-auto   "
//                 />
//               </div>
//               <div className="relative    inset-0    my-2">
//                 <div className="  m-auto    ">
//                   <img src={Top1} alt="Top1" className=" w-auto m-auto   " />
//                   <div className=" flex flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-center">
//                     {topDetails?.top_1.map((item) => (
//                       <div className="w-[32%] h-[116px] flex flex-col justify-start items-stretch relative ">
//                         <div>
//                           {" "}
//                           <img
//                             src={reward}
//                             alt="weekly Star Reward Background"
//                             className="inset-0 w-full object-cover rounded-2xl"
//                           />
//                           <img
//                             src={
//                               imageErrors[item?.image] // Check if this image has an error
//                                 ? fallbackGift
//                                 : `${ImageBaseUrl}${item?.image}`
//                             }
//                             onError={() => handleError(item?.image)} // Handle error for individual image
//                             alt={item?.name}
//                             className="w-[60px] h-[60px] absolute bottom-[39px] left-1/2 transform -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
//                           />{" "}
//                         </div>
//                         <p className=" font-tajawal  w-full  z-40  text-[#FFFFFF]  text-[8px] font-normal text-center">
//                           {item?.name}
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//               <div className="relative     inset-0     my-2">
//                 <div className="  m-auto   ">
//                   <img src={Top2} alt="Top2" className=" w-auto m-auto   " />{" "}
//                   <div className=" flex flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-center">
//                     {topDetails?.top_2.map((item) => (
//                       <div className="w-[32%] h-[116px] flex flex-col justify-start items-stretch relative ">
//                         <div>
//                           {" "}
//                           <img
//                             src={reward}
//                             alt="weekly Star Reward Background"
//                             className="inset-0 w-full object-cover rounded-2xl"
//                           />
//                           <img
//                             src={
//                               imageErrors[item?.image] // Check if this image has an error
//                                 ? fallbackGift
//                                 : `${ImageBaseUrl}${item?.image}`
//                             }
//                             onError={() => handleError(item?.image)} // Handle error for individual image
//                             alt={item?.name}
//                             className="w-[60px] h-[60px] absolute bottom-[39px] left-1/2 transform -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
//                           />{" "}
//                         </div>

//                         <p className=" font-tajawal  w-full  z-40  text-[#FFFFFF]  text-[8px] font-normal text-center">
//                           {item?.name}
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//               <div className="relative    inset-0    my-2">
//                 <div className="  m-auto   ">
//                   <img src={Top3} alt="Top3" className=" w-auto m-auto    " />{" "}
//                   <div className=" flex flex-row mx-auto justify-center flex-wrap gap-1 w-[90%] items-center">
//                     {topDetails?.top_3.map((item) => (
//                       <div className="w-[32%] h-[116px] flex flex-col justify-start items-stretch relative ">
//                         <div>
//                           {" "}
//                           <img
//                             src={reward}
//                             alt="weekly Star Reward Background"
//                             className="inset-0 w-full object-cover rounded-2xl"
//                           />
//                           <img
//                             src={
//                               imageErrors[item?.image] // Check if this image has an error
//                                 ? fallbackGift
//                                 : `${ImageBaseUrl}${item?.image}`
//                             }
//                             onError={() => handleError(item?.image)} // Handle error for individual image
//                             alt={item?.name}
//                             className="w-[60px] h-[60px] absolute bottom-[39px] left-1/2 transform -translate-x-1/2  z-0 rounded-full mx-auto " // Adjust class for proper positioning
//                           />{" "}
//                         </div>

//                         <p className=" font-tajawal  w-full  z-40  text-[#FFFFFF]  text-[8px] font-normal text-center">
//                           {item?.name}
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>{" "}
//             </div>
//           </div>
//         </div>
//       );
//     }
//   };
//   return (
//     <div className="bg-[#C83D48] relative h-full overflow-hidden">
//       <div className="  relative">
//         <AutoPlayVideoWithSound />
//         <Dialog
//           isOpen={isDialogOpen}
//           closeDialog={closeDialog}
//           description={roleEventData?.weekly_event?.description}
//         />
//         <div className="absolute bottom-[56%] z-[9999] right-0">
//           <div
//             onClick={openDialog}
//             className="relative  -right-4 inline-block cursor-pointer"
//           >
//             {" "}
//             <img
//               src={DialogButton}
//               alt="rules"
//               className=" w-[65px] md:[200px] h-auto"
//             />
//             <p className="absolute font-tajawal font-bold top-1/2 left-[46%] transform -translate-x-[56%] -translate-y-1/2 text-[#f5e489] text-sm leading-[48.32px] text-center">
//               {t("Rules")}
//             </p>
//           </div>
//         </div>
//       </div>
//       <div className="relative  -mt-[2.4rem] ">
//         {roleEventData?.weekly_event?.remainingTime ? (
//           <TimerComponent
//             initialTime={roleEventData?.weekly_event?.remainingTime}
//           />
//         ) : null}{" "}
//       </div>
//       <div className="event-tabs z-40 relative">
//         <div className="flex top-4 relative flex-wrap  mx-auto  justify-center">
//           {[
//             {
//               id: "tab1",
//               label: "This Week",
//               imgActive: activeTabBar,
//               imgInactive: tabBar,
//             },

//             {
//               id: "tab3",
//               label: "Reward",
//               imgActive: activeTabBar,
//               imgInactive: tabBar,
//             },
//           ].map((tab) => (
//             <div
//               key={tab.id}
//               className={` inline-block  relative w-[45%]  cursor-pointer `}
//               onClick={() => setActiveTab(tab.id)}
//             >
//               <img
//                 src={activeTab == tab.id ? tab.imgActive : tab.imgInactive}
//                 alt="rules"
//                 className={`w-[90%] mx-auto`}
//               />
//               <p
//                 className={`absolute w-full font-extrabold top-1/2 left-1/2 transform
//   -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%]
//   font-tajawal  first: text-center
//   lg:text-xl md:text-base sm:text-sm xs:text-[1rem]
//   ${activeTab === tab.id ? "gradient-text" : "text-[#FFFFFF66]"}`}
//               >
//                 {t(tab.label)}
//               </p>
//             </div>
//           ))}
//         </div>
//         {renderTabContent()}
//       </div>
//     </div>
//   );
// };

// export default Design;

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Dialog from "./Dialog";
import tabBar from "../../assets/images/weekly star image/notactive.png";
import activeTabBar from "../../assets/images/weekly star image/activerBar.png";
import DialogButton from "../../assets/images/weekly star image/dialog.png";
import coin from "../../assets/images/weekly star image/New folder/ic_coin 4.png";
import FirstWeeklyStarBg from "../../assets/images/weekly star image/FirstWeeklyStarBg.png";
import Top1 from "../../assets/images/weekly star image/top1.png";
import Top2 from "../../assets/images/weekly star image/Top2.png";
import Top3 from "../../assets/images/weekly star image/Top3.png";
import reward from "../../assets/images/weekly star image/singleRewardBG.png";
import Rank1 from "../../assets/images/weekly star image/Rank1.png";
import Rank2 from "../../assets/images/weekly star image/Rank2.png";
import Rank3 from "../../assets/images/weekly star image/Rank3.png";
import weeklyStarGiftBackground from "../../assets/images/weekly star image/weeklyStarGiftBG.png";
import fallbackGift from "../../assets/icons/gift-box 1.png";
import fallbackAvatar from "../../assets/icons/selected_male.png";
import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
import AutoPlayVideoWithSound from "./AutoPlayVideoWithSound";

const Design = ({
  topDetails,
  roleEventData,
  userGiftsTop,
  userGiftsTopHours,
  topWeeklyData,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [imageErrors, setImageErrors] = useState({});
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 375,
  );

  const ImageBaseUrl = "https://media.sh8afchat.com/";
  const { t } = useTranslation();

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSmallScreen = windowWidth < 375;
  const isMediumScreen = windowWidth >= 375 && windowWidth < 414;

  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true,
    }));
  };

  const rankImages = {
    1: Rank1,
    2: Rank2,
    3: Rank3,
  };

  // Enhanced ScoreBadge with glassmorphism
  const ScoreBadge = ({ score }) => (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className="flex items-center gap-1 bg-gradient-to-r from-yellow-400/30 to-yellow-600/30 backdrop-blur-sm px-2 py-1 rounded-full border border-yellow-400/30"
    >
      <img
        src={coin}
        alt="coin"
        className="w-4 h-4 sm:w-5 sm:h-5 animate-pulse"
      />
      <span className="text-[#FCEA98] font-bold text-sm sm:text-base drop-shadow-lg">
        {parseInt(score)?.toLocaleString() || "0"}
      </span>
    </motion.div>
  );

  // Enhanced Avatar with glow effect
  const AvatarImage = ({
    imageUrl,
    size = "w-12 h-12 sm:w-14 sm:h-14",
    className = "",
  }) => (
    <div className="relative group">
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400 rounded-full blur-xl opacity-75 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full blur-sm opacity-50" />
      <img
        src={
          imageErrors[imageUrl] ? fallbackAvatar : `${ImageBaseUrl}${imageUrl}`
        }
        onError={() => handleError(imageUrl)}
        className={`${size} rounded-full border-2 border-yellow-400 shadow-xl relative z-10 object-cover transform group-hover:scale-110 transition-transform duration-300 ${className}`}
        alt="avatar"
      />
    </div>
  );

  // Enhanced Winner List Item with better animations
  const WinnerListItem = ({ item, position, isUser = false }) => (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: position * 0.05 }}
      whileHover={{ scale: 1.02, x: 5 }}
      className={`relative overflow-hidden rounded-2xl mb-2 ${
        isUser
          ? "bg-gradient-to-r from-purple-600/40 to-pink-600/40 border border-purple-400/50"
          : "bg-gradient-to-r from-white/10 to-white/5 border border-white/10"
      } backdrop-blur-md shadow-lg`}
    >
      {/* Shimmer effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full animate-shimmer" />

      {/* Glow effect for user */}
      {isUser && (
        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 animate-pulse" />
      )}

      <div className="flex items-center justify-between p-2 sm:p-3 relative z-10">
        <div className="flex items-center gap-2 sm:gap-3 flex-1">
          <motion.span
            whileHover={{ scale: 1.2, rotate: 5 }}
            className={`text-yellow-400 font-bold text-base sm:text-lg w-6 sm:w-8 drop-shadow-lg ${
              position <= 3 ? "animate-bounce" : ""
            }`}
          >
            #{position}
          </motion.span>

          <div className="flex items-center gap-2 sm:gap-3">
            <AvatarImage
              imageUrl={item.avatar}
              size="w-10 h-10 sm:w-12 sm:h-12"
            />

            <div className="flex-1 z-50 min-w-0">
              <p className="text-[#FCEA98] font-bold text-xs sm:text-sm truncate max-w-[100px] sm:max-w-[150px] drop-shadow-md">
                {item.name}
              </p>
              <p className="text-white/90 text-xs sm:text-sm drop-shadow">
                ID: {item.user_id}
              </p>
            </div>
          </div>
        </div>

        <ScoreBadge score={item.totalGiftNum} />
      </div>
    </motion.div>
  );

  // Enhanced Ranking Card with 3D effect
  const RankingCard = ({ rank, userData, rankImage }) => {
    const configs = {
      1: {
        height: "h-[220px] sm:h-[220px]",
        avatarSize: "w-16 h-16 sm:w-16 sm:h-16",
        avatarTop: "top-12 sm:top-12",
        contentBottom: "bottom-5 sm:bottom-5",
        glowColor: "from-yellow-400 to-yellow-600",
      },
      2: {
        height: "h-[180px] sm:h-[180px]",
        avatarSize: "w-14 h-14 sm:w-14 sm:h-14",
        avatarTop: "top-[1.6rem] sm:top-[1.6rem]",
        contentBottom: "bottom-2 sm:bottom-2",
        glowColor: "from-gray-300 to-gray-400",
      },
      3: {
        height: "h-[180px] sm:h-[180px]",
        avatarSize: "w-14 h-14 sm:w-14 sm:h-14",
        avatarTop: "top-[1.5rem]  sm:top-[1.6rem]",
        contentBottom: "bottom-2 sm:bottom-2",
        glowColor: "from-amber-600 to-amber-700",
      },
    };

    const config = configs[rank];

    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: rank * 0.1 }}
        whileHover={{ y: -5 }}
        className="relative group"
      >
        {/* Background glow */}
        <div
          className={`absolute inset-0 bg-gradient-to-r ${config.glowColor} rounded-2xl blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-500`}
        />

        <img
          src={rankImage}
          alt={`Rank ${rank}`}
          className={`${config.height} w-auto mx-auto object-contain drop-shadow-2xl relative z-10 transform group-hover:scale-105 transition-transform duration-300`}
        />

        <div className="absolute inset-0 flex flex-col items-center">
          <motion.div
            whileHover={{ scale: 1.1 }}
            className={`absolute ${config.avatarTop} transform -translate-x-1/2 left-1/2`}
          >
            <AvatarImage
              imageUrl={userData?.avatar}
              size={config.avatarSize}
              className="border-3 border-yellow-400 shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: rank * 0.2 }}
            className={`absolute ${config.contentBottom} z-50 w-full px-2 text-center`}
          >
            <p className="text-[#FCEA98] z-50 font-bold text-xs sm:text-sm truncate max-w-[80px] mx-auto drop-shadow-lg">
              {userData?.name}
            </p>
            <p className="text-white/90 z-50 text-[10px] sm:text-xs drop-shadow">
              ID: {userData?.user_id}
            </p>
            <p className="text-white/90 z-50 text-[10px] sm:text-xs drop-shadow">
              UUID: {userData?.uuid}
            </p>
            <motion.div
              whileHover={{ scale: 1.1 }}
              className="flex items-center justify-center gap-1 mt-1 bg-black/30 backdrop-blur-sm rounded-full px-2 py-0.5 mx-auto w-fit"
            >
              <img
                src={coin}
                alt="coin"
                className="w-3 h-3 sm:w-4 sm:h-4 animate-spin-slow"
              />
              <span className="text-[#FCEA98] font-bold text-xs sm:text-sm">
                {userData?.totalGiftNum}
              </span>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    );
  };

  // Enhanced Winners List with better scrolling
  const WinnersList = ({ winners }) => {
    if (!winners?.length) return null;

    return (
      <div className="px-3 sm:px-4 space-y-2 max-h-[300px] overflow-y-auto custom-scrollbar">
        {winners.map((item, index) => (
          <WinnerListItem key={index} item={item} position={index + 4} />
        ))}
      </div>
    );
  };

  // Enhanced Gift Card
  const GiftCard = ({ item, index, background, isReward = false }) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.05 }}
      whileHover={{
        scale: 1.1,
        rotate: [0, -5, 5, 0],
        transition: { duration: 0.3 },
      }}
      className="relative aspect-square group"
    >
      {/* Glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/30 to-yellow-600/30 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <img
        src={background}
        alt="gift background"
        className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
      />

      <img
        src={
          imageErrors[item?.image]
            ? fallbackGift
            : `${ImageBaseUrl}${item?.image}`
        }
        onError={() => handleError(item?.image)}
        alt={item?.name}
        className="absolute inset-0 w-2/4 h-2/4 rounded-full m-auto object-contain transform group-hover:rotate-12 transition-transform duration-300"
      />

      {!isReward && (
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex items-center gap-1 bg-black/50 backdrop-blur-sm rounded-full px-2 py-0.5 border border-yellow-400/30"
        >
          <img src={coin} alt="coin" className="w-3 h-3 " />
          <span className="text-[#FCEA98] text-[10px] sm:text-xs font-bold">
            {item?.price}
          </span>
        </motion.div>
      )}

      {isReward && (
        <p className="absolute -bottom-3 left-0 right-0 text-white text-[10px] sm:text-xs text-center truncate px-1 drop-shadow-lg">
          {item?.name}
        </p>
      )}
    </motion.div>
  );

  const renderTabContent = () => {
    if (activeTab === "tab1") {
      return (
        <motion.div
          key="tab1"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
          className="px-3 pb-20"
        >
          {/* Gifts Grid */}
          {roleEventData?.weekly_event?.gifts && (
            <div className="mb-6">
              <div className="grid grid-cols-3 gap-4  ">
                {roleEventData.weekly_event.gifts.map((item, index) => (
                  <GiftCard
                    key={index}
                    item={item}
                    index={index}
                    background={weeklyStarGiftBackground}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Rankings */}
          {topWeeklyData?.top && (
            <>
              <div className="relative mb-6">
                {/* Top 1 */}
                {topWeeklyData.top[0] && (
                  <div className="mb-4">
                    <RankingCard
                      rank={1}
                      userData={topWeeklyData.top[0]}
                      rankImage={rankImages[1]}
                    />
                  </div>
                )}

                {/* Top 2 & 3 */}
                <div className="flex justify-center gap-3 sm:gap-4 mb-6">
                  {[2, 3].map((rank) => {
                    const userData = topWeeklyData.top[rank - 1];
                    if (!userData) return null;

                    return (
                      <div key={rank} className="flex-1 max-w-[160px]">
                        <RankingCard
                          rank={rank}
                          userData={userData}
                          rankImage={rankImages[rank]}
                        />
                      </div>
                    );
                  })}
                </div>

                {/* Rest of winners */}
                {topWeeklyData.top.length > 3 && (
                  <WinnersList winners={topWeeklyData.top.slice(3)} />
                )}
              </div>

              {/* Current User Rank */}
              {topWeeklyData?.user && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  className="fixed bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-[#C83D48] via-[#C83D48]/95 to-transparent backdrop-blur-sm"
                >
                  <WinnerListItem
                    item={topWeeklyData.user}
                    position={topWeeklyData.user.rank || "—"}
                    isUser={true}
                  />
                </motion.div>
              )}
            </>
          )}
        </motion.div>
      );
    }

    if (activeTab === "tab3") {
      return (
        <motion.div
          key="tab3"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
          className="px-3 pb-8"
        >
          <img
            src={FirstWeeklyStarBg}
            alt={`Top  `}
            className="h-24 my-2  mx-auto object-contain drop-shadow-lg"
          />{" "}
          {[1, 2, 3].map((tier) => {
            const tierData = topDetails?.[`top_${tier}`];
            if (!tierData?.length) return null;

            return (
              <motion.div
                key={tier}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: tier * 0.1 }}
                className="mb-8"
              >
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="text-center mb-3"
                >
                  <img
                    src={tier === 1 ? Top1 : tier === 2 ? Top2 : Top3}
                    alt={`Top ${tier}`}
                    className="h-8 sm:h-10 mx-auto object-contain drop-shadow-lg"
                  />
                </motion.div>

                <div className="grid grid-cols-3 gap-4  ">
                  {tierData.map((item, index) => (
                    <GiftCard
                      key={index}
                      item={item}
                      index={index}
                      background={reward}
                      isReward={true}
                    />
                  ))}
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      );
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#C83D48] via-[#B03540] to-[#8B2C34] relative overflow-hidden">
      {/* Video Background with Overlay */}
      <div className="  inset-0  ">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#C83D48]/50 to-[#C83D48] z-10" />
        <AutoPlayVideoWithSound />
      </div>

      {/* Content */}
      <div className="relative z-20">
        {/* Rules Button */}
        <AnimatePresence>
          <motion.button
            initial={{ x: 100, rotate: 10 }}
            animate={{ x: 0, rotate: 0 }}
            whileHover={{ scale: 1.1, rotate: 5 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => setIsDialogOpen(true)}
            className="absolute -top-60   right-2 z-50"
          >
            <div className="relative">
              <img
                src={DialogButton}
                alt="rules"
                className="w-16 sm:w-20 h-auto drop-shadow-2xl"
              />
              <motion.span
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="absolute inset-0 flex items-center justify-center text-[#f5e489] font-bold text-sm sm:text-base drop-shadow-lg"
              >
                {t("Rules")}
              </motion.span>
            </div>
          </motion.button>
        </AnimatePresence>

        {/* Timer with glow */}
        {roleEventData?.weekly_event?.remainingTime && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="pt-16 pb-4"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 rounded-full blur-xl" />
              <TimerComponent
                initialTime={roleEventData.weekly_event.remainingTime}
              />
            </div>
          </motion.div>
        )}

        {/* Enhanced Tabs */}
        <div className="flex justify-center gap-2 px-4 mb-6">
          {[
            { id: "tab1", label: t("This Week") },
            { id: "tab3", label: t("Rewards") },
          ].map((tab) => (
            <motion.button
              key={tab.id}
              whileTap={{ scale: 0.95 }}
              onClick={() => setActiveTab(tab.id)}
              className="relative flex-1 max-w-[160px] group"
            >
              <motion.img
                whileHover={{ scale: 1.05 }}
                src={activeTab === tab.id ? activeTabBar : tabBar}
                alt={tab.label}
                className="w-full h-auto drop-shadow-lg"
              />
              <motion.span
                animate={activeTab === tab.id ? { scale: [1, 1.05, 1] } : {}}
                transition={{ duration: 2, repeat: Infinity }}
                className={`absolute inset-0 flex items-center justify-center text-sm sm:text-base font-bold ${
                  activeTab === tab.id
                    ? "text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600 drop-shadow-lg"
                    : "text-white/60 group-hover:text-white/80 transition-colors"
                }`}
              >
                {tab.label}
              </motion.span>
            </motion.button>
          ))}
        </div>

        {/* Tab Content */}
        <AnimatePresence mode="wait">{renderTabContent()}</AnimatePresence>
      </div>

      {/* Dialog */}
      <Dialog
        isOpen={isDialogOpen}
        closeDialog={() => setIsDialogOpen(false)}
        description={roleEventData?.weekly_event?.description}
      />

      {/* Global Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.4);
        }
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .animate-shimmer {
          animation: shimmer 2s infinite;
        }
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Design;
